exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading[data-v-719f2818] {\n  margin: 80px 0px;\n  font-size: 20px;\n  font-weight: bold;\n  text-align: center;\n}", ""]);

// exports
